import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-background-50 paper-texture">
      <div className="flex-1 flex flex-col items-center justify-center text-center px-4 py-20">
        <p className="font-mono-num text-6xl md:text-8xl font-bold text-primary-500">404</p>
        <h1 className="mt-5 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          这条瓜还没长出来
        </h1>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-md leading-relaxed">
          你访问的页面不存在，可能已经被合并或更名。
          <span className="block mt-1 font-mono-num text-xs text-foreground-400">{location.pathname}</span>
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <Link
            to="/"
            className="px-6 py-3 rounded-control bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            回到首页
          </Link>
          <Link
            to="/gossip"
            className="px-6 py-3 rounded-control border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            浏览爆料库
          </Link>
        </div>
      </div>
    </div>
  );
}